import {
  GET_AUDIT_PROCESS,
  GET_AUDIT_PROCESS_DETAIL,
  GET_AUDIT_PROCESS_FILTER_DEPARTMENT,
  GET_AUDIT_SCHEDULE,
  GET_AUDIT_SCHEDULE_DETAIL,
  GET_AUDIT_SCHEDULE_FILTER_DEPARTMENT,
  GET_AUDIT_SCHEDULE_FILTER_PROCESS,
  GET_AUDIT_SCHEDULE_PRINT,
  GET_PROCESS_CHECK_POINT,
  GET_PROCESS_CHECK_POINT_DETAIL,
  GET_PROCESS_CHECK_POINT_FILTER_DEPARTMENT,
  GET_PROCESS_CHECK_POINT_FILTER_PROCESS,
  GET_PROCESS_CHECK_POINT_OPTION,
  GET_PROCESS_DOCUMENTS,
  GET_PROCESS_DOCUMENTS_DETAIL,
  GET_PROCESS_DOCUMENTS_FILTER_DEPARTMENT,
  // Audit Calendar
  GET_AUDIT_CALENDAR,
  GET_AUDIT_CALENDAR_FILTER_DEPARTMENT,
  GET_AUDIT_CALENDAR_FILTER_PROCESS,
  GET_AUDIT_CALENDAR_FILTER_STATUS,
  // Audit Observation
  GET_AUDIT_SCHEDULE_OBSERVATION,
  GET_AUDIT_SCHEDULE_OBSERVATION_EXPORT,
  GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_DEPARTMENT,
  GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_PROCESS,
  GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_ASSIGNED_TO,
  GET_AUDIT_SCHEDULE_OBSERVATION_DETAIL,
  GET_PROCESS_CHECK_POINT_EXPORT,
  GET_AUDIT_SCHEDULE_EXPORT,
  GET_AUDIT_CALENDAR_EXPORT,
  GET_AUDIT_PROCESS_EXPORT,
  GET_PROCESS_CHECK_POINT_OPTION_EXPORT,
  // Check point template
  AUDIT_CHECK_POINT_TEMPLATE,
  AUDIT_OBSERVATION_TEMPLATE,
  GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_DATE,
  GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_PROCESS_TEMPLATE,
  GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_DEPARTMENT_TEMPLATE,
  GET_PROCESS_CHECK_POINT_FILTER_DEPARTMENT_TEMPLATE,
  GET_PROCESS_CHECK_POINT_FILTER_PROCESS_TEMPLATE,
  GET_PROCESS_CHECK_POINT_FILTER_OCCURENCE
} from "./types";

// const initialStateChart = {
//   labels: [],
//   datasets: []
// };
const initialState = {
  //QC STAGE
  getAuditProcess: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditProcessDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditProcessFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcessDocuments: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcessDocumentsDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcessDocumentsFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcessCheckPointOption: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcessCheckPoint: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcessCheckPointFilterProcess: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcessCheckPointFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcessCheckPointDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditSchedule: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditScheduleFilterProcess: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditScheduleFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditScheduleDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditSchedulePrint: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Audit Calendar
  getAuditCalendar: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditCalendarFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditCalendarFilterProcess: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditCalendarFilterStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Audit Observation
  getAuditScheduleObservation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditScheduleObservationExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditScheduleObservationFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditScheduleObservationFilterProcess: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditScheduleObservationFilterAssignedTo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditScheduleObservationDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcessCheckPointExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditScheduleExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditCalendarExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditProcessExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getProcessCheckPointOptionExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Check point template
  auditCheckPointTemplate: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  auditObservationTemplate: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditScheduleObservationFilterDate: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditScheduleObservationFilterDepartmentTemplate: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAuditScheduleObservationFilterProcessTemplate: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcessCheckPointFilterProcessTemplate: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcessCheckPointFilterDepartmentTemplate: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getProcessCheckPointFilterOccurence: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  }
};
const Audit_reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    //QC STAGE

    case GET_AUDIT_PROCESS:
      return Object.assign({}, state, {
        getAuditProcess: payload
      });
    case GET_AUDIT_PROCESS_DETAIL:
      return Object.assign({}, state, {
        getAuditProcessDetail: payload
      });
    case GET_AUDIT_PROCESS_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getAuditProcessFilterDepartment: payload
      });
    case GET_PROCESS_DOCUMENTS:
      return Object.assign({}, state, {
        getProcessDocuments: payload
      });
    case GET_PROCESS_DOCUMENTS_DETAIL:
      return Object.assign({}, state, {
        getProcessDocumentsDetail: payload
      });
    case GET_PROCESS_DOCUMENTS_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getProcessDocumentsFilterDepartment: payload
      });
    case GET_PROCESS_CHECK_POINT_OPTION:
      return Object.assign({}, state, {
        getProcessCheckPointOption: payload
      });
    case GET_PROCESS_CHECK_POINT:
      return Object.assign({}, state, {
        getProcessCheckPoint: payload
      });
    case GET_PROCESS_CHECK_POINT_FILTER_PROCESS:
      return Object.assign({}, state, {
        getProcessCheckPointFilterProcess: payload
      });
    case GET_PROCESS_CHECK_POINT_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getProcessCheckPointFilterDepartment: payload
      });
    case GET_PROCESS_CHECK_POINT_DETAIL:
      return Object.assign({}, state, {
        getProcessCheckPointDetail: payload
      });
    case GET_AUDIT_SCHEDULE:
      return Object.assign({}, state, {
        getAuditSchedule: payload
      });
    case GET_AUDIT_SCHEDULE_FILTER_PROCESS:
      return Object.assign({}, state, {
        getAuditScheduleFilterProcess: payload
      });
    case GET_AUDIT_SCHEDULE_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getAuditScheduleFilterDepartment: payload
      });
    case GET_AUDIT_SCHEDULE_DETAIL:
      return Object.assign({}, state, {
        getAuditScheduleDetail: payload
      });
    case GET_AUDIT_SCHEDULE_PRINT:
      return Object.assign({}, state, {
        getAuditSchedulePrint: payload
      });
    // Audit Calendar
    case GET_AUDIT_CALENDAR:
      return Object.assign({}, state, {
        getAuditCalendar: payload
      });
    case GET_AUDIT_CALENDAR_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getAuditCalendarFilterDepartment: payload
      });
    case GET_AUDIT_CALENDAR_FILTER_PROCESS:
      return Object.assign({}, state, {
        getAuditCalendarFilterProcess: payload
      });
    case GET_AUDIT_CALENDAR_FILTER_STATUS:
      return Object.assign({}, state, {
        getAuditCalendarFilterStatus: payload
      });
    // Audit Observation
    case GET_AUDIT_SCHEDULE_OBSERVATION:
      return Object.assign({}, state, {
        getAuditScheduleObservation: payload
      });
    case GET_AUDIT_SCHEDULE_OBSERVATION_EXPORT:
      return Object.assign({}, state, {
        getAuditScheduleObservationExport: payload
      });
    case GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getAuditScheduleObservationFilterDepartment: payload
      });
    case GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_PROCESS:
      return Object.assign({}, state, {
        getAuditScheduleObservationFilterProcess: payload
      });
    case GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_ASSIGNED_TO:
      return Object.assign({}, state, {
        getAuditScheduleObservationFilterAssignedTo: payload
      });
    case GET_AUDIT_SCHEDULE_OBSERVATION_DETAIL:
      return Object.assign({}, state, {
        getAuditScheduleObservationDetail: payload
      });
    case GET_PROCESS_CHECK_POINT_EXPORT:
      return Object.assign({}, state, {
        getProcessCheckPointExport: payload
      });
    case GET_AUDIT_SCHEDULE_EXPORT:
      return Object.assign({}, state, {
        getAuditScheduleExport: payload
      });
    case GET_AUDIT_CALENDAR_EXPORT:
      return Object.assign({}, state, {
        getAuditCalendarExport: payload
      });
    case GET_AUDIT_PROCESS_EXPORT:
      return Object.assign({}, state, {
        getAuditProcessExport: payload
      });
    case GET_PROCESS_CHECK_POINT_OPTION_EXPORT:
      return Object.assign({}, state, {
        getProcessCheckPointOptionExport: payload
      });
    // Check point template

    case AUDIT_CHECK_POINT_TEMPLATE:
      return Object.assign({}, state, {
        auditCheckPointTemplate: payload
      });
    case AUDIT_OBSERVATION_TEMPLATE:
      return Object.assign({}, state, {
        auditObservationTemplate: payload
      });
    case GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_DATE:
      return Object.assign({}, state, {
        getAuditScheduleObservationFilterDate: payload
      });
    case GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_DEPARTMENT_TEMPLATE:
      return Object.assign({}, state, {
        getAuditScheduleObservationFilterDepartmentTemplate: payload
      });
    case GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_PROCESS_TEMPLATE:
      return Object.assign({}, state, {
        getAuditScheduleObservationFilterProcessTemplate: payload
      });
    case GET_PROCESS_CHECK_POINT_FILTER_PROCESS_TEMPLATE:
      return Object.assign({}, state, {
        getProcessCheckPointFilterProcessTemplate: payload
      });
    case GET_PROCESS_CHECK_POINT_FILTER_DEPARTMENT_TEMPLATE:
      return Object.assign({}, state, {
        getProcessCheckPointFilterDepartmentTemplate: payload
      });
    case GET_PROCESS_CHECK_POINT_FILTER_OCCURENCE:
      return Object.assign({}, state, {
        getProcessCheckPointFilterOccurence: payload
      });
    default:
      return state;
  }
};
export default Audit_reducer;
